import { useCallback, useEffect, useState } from 'react';
import { ViolationError } from '@app/lib/form/contracts/ViolationError';

export function useShowErrorState<E>(error?: ViolationError, onChange?: (e: E) => void): [boolean, (e: E) => void] {
    const [showError, setShowError] = useState(false);

    const handleChange = useCallback(
        (e: E) => {
            setShowError(false);

            onChange?.(e);
        },
        [onChange],
    );

    useEffect(() => {
        setShowError(true);
    }, [error]);

    return [showError, handleChange];
}
